export default __webpack_public_path__ + "static/media/headset-info.557baa5d.png";